import React from 'react';
import CompositeListFunctional from './components/composites-list-functional';
import './composites.scss';

const CompositeList = () => <CompositeListFunctional />

export default CompositeList;
